import { render, staticRenderFns } from "./menuShopCart.vue?vue&type=template&id=1393015c&scoped=true"
import script from "./menuShopCart.vue?vue&type=script&lang=ts"
export * from "./menuShopCart.vue?vue&type=script&lang=ts"
import style0 from "./menuShopCart.vue?vue&type=style&index=0&id=1393015c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1393015c",
  null
  
)

export default component.exports